import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import toast from 'react-hot-toast';

export const bundleUpdateValidationToast = () => {
  toast.custom(
    (t) => (
      <div
        className={`${
          t.visible ? 'animate-enter' : 'animate-leave'
        } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
      >
        <div className="flex-1 w-0 p-4">
          <div className="flex h-full gap-4">
            <div className="flex justify-center items-center">
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                className={sprinkles({ color: 'P-60', fontSize: '2xl' })}
              />
            </div>
            <div className="flex flex-col">
              <Typography variant="body" size="medium" color="N-80">
                Exclude from Platform users first
              </Typography>
              <Typography variant="body" size="small" color="N-60">
                To exclude item from Exclusive Access you must first exclude
                them from Platform users.
              </Typography>
            </div>
          </div>
        </div>
        <div
          className="flex justify-center items-center border-l border-gray-200 cursor-pointer px-5"
          onClick={() => toast.dismiss(t.id)}
        >
          <Typography variant="body" size="medium" color="P-60">
            Close
          </Typography>
        </div>
      </div>
    ),
    { duration: 4000 },
  );
};
